import { TenderExportProp } from 'gen/ApiClient';
import React from 'react';

interface IViewContext {
	exportRecord: Record<TenderExportProp, string>;
}

export const TendersListViewContext = React.createContext<IViewContext>(undefined as any);
